import { render } from "./TaxonomyEditorApp.vue?vue&type=template&id=3c2bcac0&scoped=true"
import script from "./TaxonomyEditorApp.vue?vue&type=script&lang=js"
export * from "./TaxonomyEditorApp.vue?vue&type=script&lang=js"

import "./TaxonomyEditorApp.vue?vue&type=style&index=0&id=3c2bcac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2bcac0"]])

export default __exports__